// @ts-ignore
import userStore from '@/stores/user/index';

// 获取 display_logic 的实验组
export const getAgentConnectionAutoFillLogic = () => {
  return (userStore.newABTestingConfigs as any)?.live_agent_connection_auto_fill;
};

export const isAgentConnectionAutoFill = () => {
  return (userStore.newABTestingConfigs as any)?.live_agent_connection_auto_fill === 'agent_connection_with_autofill';
};


